import useStyles from "./styles"
import { useSteering, useUserAuthToken, useIsUserAuthorized } from "../../../redux/hook/userHooks"
import { useSetPreferredSteeringMutation } from "../../../redux/services/broditWebApi"
import { changeSteering } from "../../../redux/userSlice"
import {
    Box, FormControl, FormControlLabel, Radio, RadioGroup
} from "@material-ui/core"
import React from "react"
import { useDispatch } from "react-redux"

function LeftRightSteeringFilter() {
    const classes = useStyles()
    const dispatch = useDispatch()
    const steering = useSteering()

    const isUserAuthorized = useIsUserAuthorized()
    const authToken = useUserAuthToken()

    const [setPreferredSteering] = useSetPreferredSteeringMutation()

    const handleOnChange = event => {
        const preferredSteering = event.target.value

        if (isUserAuthorized) {
            setPreferredSteering({
                preferredSteering: preferredSteering,
                authToken: authToken
            })
        }

        dispatch(changeSteering(preferredSteering))
    }

    return (
        <Box id="LDHRHD">
            <FormControl component="fieldset">
                <RadioGroup
                    aria-label="steering"
                    value={steering}
                    onChange={handleOnChange}
                >
                    <FormControlLabel
                        classes={{
                            label: classes.label
                        }}
                        value="1"
                        control={(
                            <Radio
                                size="small"
                                className={classes.hover}
                                classes={{
                                    root: classes.icon,
                                    checked: classes.checked
                                }}
                            />
                        )}
                        label="LHD"
                    />
                    <FormControlLabel
                        classes={{
                            label: classes.label
                        }}
                        value="2"
                        control={(
                            <Radio
                                size="small"
                                className={classes.hover}
                                classes={{
                                    root: classes.icon,
                                    checked: classes.checked
                                }}
                            />
                        )}
                        label="RHD"
                    />
                    {/* NotApplicable value="4" */}
                </RadioGroup>
            </FormControl>
        </Box>
    )
}

export default LeftRightSteeringFilter
